// DON't forget update index.html after update types!
export const envConfig = (process.env.NODE_ENV === 'development' ? process.env : (window as any).env) as {
  SENTRY_DSN: string;
  NODE_ENV: string;
};
